<template>
<v-card>
	<v-card-text>
		<v-container>
			<v-form ref="token-share" v-model="formValid">
			<v-layout row wrap>
				<v-flex xs12>
					<v-alert
					:value="status.error"
					type="error"
					icon="warning"
					>
					{{status.error}}
					</v-alert>
				</v-flex>
				<v-flex xs12>
					<v-layout row>
						<v-flex xs6>
						<v-checkbox
						label="Public share"
						v-model="isPublic"
						@change="validate"
						></v-checkbox>
						</v-flex>
						
						<v-flex xs6>
						<v-switch
						label="Show on public page"
						v-model="isPublicVisible"
						v-show="isPublic"
						></v-switch>
						</v-flex>
					</v-layout>
					<v-text-field
						label="Share with"
						placeholder="Enter the recipient's user name"
						hint="Please provide a user name"
						v-model="recipient"
						:rules="[...requiredRules]"
						:append-icon="recipientExists ? 'fa-user-check' : null"
						:color="recipientExists ? 'success' : 'primary'"
						:disabled="isPublic"
						v-show="!isPublic"
						ref="recipient"
					></v-text-field>
				</v-flex>
				<v-flex xs6>
					<v-switch
					label="Can read"
					v-model="access.read"
					:disabled="!recipientExists || isPublic"
					v-show="!isPublic"
					></v-switch>
					<v-switch
					label="Can write"
					v-model="access.write"
					:disabled="!recipientExists || isPublic"
					v-show="!isPublic"
					></v-switch>
					<v-switch
					label="Can re-share"
					v-model="access.share"
					:disabled="!recipientExists || isPublic"
					v-show="!isPublic"
					></v-switch>
				</v-flex>
				<v-flex xs6>
				
					<v-switch
					label="Set expiry date"
					v-model="shareExpires"
					:disabled="!recipientExists && !isPublic"
					@change="v => v && (expiryDatePicker = true)"
					></v-switch>
					
					<v-menu
					:close-on-content-click="false"
					v-model="expiryDatePicker"
					:nudge-right="40"
					lazy
					transition="scale-transition"
					offset-y
					full-width
					min-width="290px"
					:disabled="!recipientExists && !isPublic"
					v-show="shareExpires"
					>
						<v-text-field
						slot="activator"
						v-model="expiry"
						label="Expiry"
						prepend-icon="fa-event"
						readonly
						></v-text-field>
						<v-date-picker
						v-model="expiry"
						:min="minExpiryDate"
						@input="expiryDatePicker = false"
						></v-date-picker>
					</v-menu>
				
				
				</v-flex>
			</v-layout>
			</v-form>
		</v-container>
	</v-card-text>
	<v-card-actions>
		<v-spacer/>
		<v-btn flat color="primary"
		:disabled="!formValid"
		@click="submit">
			<v-icon left>fa-save</v-icon>
			Save
		</v-btn>
	</v-card-actions>
</v-card>
</template>

<script>
import Vuex from 'vuex'
import * as moment from 'moment'
import api from '../../assets/js/api-instance'

export default {
	name: "FollowTokenShareForm",
	
	props: {
		item: Object
	},

	data () {
		return {
			token_id: null,
			metadata: {},
			isPublic: false,
			isPublicVisible: false,
			recipient: null,
			recipient_id: null,
			recipientExists: false,
			access: {
				read: true,
				write: false,
				remove: false,
				share: true
			},
			expiry: null,
			
			shareExpires: false,
			expiryDatePicker: false,
			minExpiryDate: moment().add(1, 'day').format("YYYY-MM-DD"),
			formValid: false,
			requiredRules: [
				v=> this.isPublic || this.recipientExists || (v && v.length > 0
					? "Recipient does not exist"
					: "Please provide a user name")
			],
			status: {}
		};
	},
	
	watch: {
		item (item) {
			this.setData(item);
		},
		
		async recipient (value) {
			if (value) {
				try {
					const res = await api.checkHandleExists(value);
					console.log("RES", res);
					this.recipientExists = !!res;
					this.recipient_id = res.user_id;
				} catch (err) {
					this.recipientExists = false;
					this.recipient_id = null;
				}
				this.validate();
			} else {
				this.$refs["recipient"].reset();
			}
		}
	},
	
	methods: {
		setData (item) {
			this.token_id = item.r_token_id;
			this.isPublic = item.user_id == "00000000";
			this.isPublicVisible = this.isPublic && item.permissions.includes("s");
			this.recipient_id = item.user_id;
			this.recipient = item.handle;
			this.access.read = item.permissions.includes("r");
			this.access.write = item.permissions.includes("c");
			this.access.remove = !this.isPublic && item.permissions.includes("d");
			this.access.share = !this.isPublic && item.permissions.includes("s");
			this.expiry = item.expiry ? moment(item.expiry).format("YYYY-MM-DD") : null;
			this.shareExpires = !!item.expiry;
			this.metadata = item.metadata;
		},
		
		reset () {
			this.token_id = null;
			this.access = {
				read: true,
				write: false,
				remove: false,
				share: false
			};
			this.metadata = {};
			this.$refs["token-share"].reset();
		},
		
		validate () {
			this.$refs["token-share"].validate();
		},
		
		async submit () {
			if (this.formValid) {
				let permissions = [
					this.access.write && 'c',
					this.access.read && 'r',
					this.access.remove && 'd',
					this.access.share && 's'
				].filter(a => a).join("");
				try {
					let res = await api.shareToken(this.token_id, {
						public: this.isPublic,
						public_visible: this.isPublicVisible,
						recipient_id: this.recipient_id,
						permissions,
						expiry: this.shareExpires && this.expiry
					});
					console.log("shared", res);
					this.$emit("shared");
					this.reset();
				} catch (err) {
					if (err.unauthorised) {
						this.status = { error: "Unauthorised" };
					} else if (err.code == "network_error") {
						this.status = { error: "Network error" };
					} else {
						this.status = { error: "Unknown error" };
					}
				}
			}
		}
	},
	
	created () {
		if (this.item) {
			this.setData(this.item);
		}
	}

}
</script>
